import { useState, useEffect, useRef } from "react";
import PetInformation from "../PetInformation";
import { useRouter } from "@/app/hooks/useRouter";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";

const XrayConsentForm = () => {
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id"));
  const { customerDetails, petDetails } = routeState.state as ICustomerProfileState;

  const consentTexts = [
    "I hereby authorize and permit an X-ray/USG to be performed by the Veterinarian in the above-named clinic.",
    "I have been apprised by the staff of the VETIC pet clinic regarding the specifics of the procedure and the rationale behind the requirement of the procedure on the above-mentioned pet.",
    "I acknowledge that in the event of excessive movement by the pet during the X-ray/USG process, the staff may find it necessary to employ safety gear such as a Muzzle or E-Collar to safeguard the well-being of the animal. Additionally, manual restraint may be applied by the staff as deemed necessary for the successful completion of the procedure.",
    "Furthermore, I am aware that access to the X-ray/USG room is restricted to me, to prevent potential exposure to radiation that could pose harm to me.",
    "I have read and understood this consent form. I consent to the proposed procedures.",
  ];
  const text = `I ${customerDetails?.name} am the owner/authorised agent of the pet ${petDetails?.name} and have the authority to execute this consent. I authorize Vetic Pet Clinic and its staff to examine and perform X-rays for the above-described patient/pet.`;
  const text2 = `I ${customerDetails?.name} am am the legal owner of the above-mentioned animal and authorized representative of the Owner`;
  return (
    <div>
      <div>
        <PetInformation />
      </div>
      <p className="py-2 font-semibold pt-2">Treatment Consent:</p>
      <DynamicTextarea key={0} initialValue={text} />
      <p className="py-2 font-semibold pt-2">Terms & Conditions:</p>
      <DynamicTextarea key={1} initialValue={text2} />
      {consentTexts.map((text, index) => (
        <DynamicTextarea key={index} initialValue={text} />
      ))}

      <div className="mt-8 flex justify-between">
        <p>Date</p>
        <p>Signature of Pet Owner</p>
      </div>
    </div>
  );
};

const DynamicTextarea = ({ initialValue }: { initialValue: string }) => {
  const [value, setValue] = useState(initialValue);
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    adjustHeight();
  }, [value]);

  const adjustHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Adjust to content
    }
  };

  return (
    <div className="print-textarea">
      <textarea
        ref={textareaRef}
        className="w-full border p-2 print:hidden text-xs resize-none scrollbar-thin"
        value={value} // Controlled component to retain content
        onChange={(e) => setValue(e.target.value)}
        onInput={adjustHeight}
        style={{
          overflowY: "auto",
          scrollbarWidth: "thin",
        }}
      />
      <div className="hidden print:block  w-full print:border-none p-2 text-xs whitespace-pre-wrap">{value}</div>
    </div>
  );
};

export default XrayConsentForm;
